import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { RichText } from 'prismic-reactjs'
import Prismic from 'prismic-javascript'

import Page from '../../components/Page'

import './style.css'

const apiEndpoint = 'https://buda-vet.cdn.prismic.io/api/v2'

class NewsItem extends Component {
  state = {
    newsItem: {},
  }

  async componentDidMount() {
    const api = await Prismic.getApi(apiEndpoint)
    const newsItemId = this.props.match.params.id

    api.getByID(newsItemId).then(apiResult => {
      console.log(apiResult.data)
      this.setState({
        newsItem: { ...apiResult.data, id: apiResult.id },
      })
    })
  }

  render() {
    const newsItem = this.state.newsItem
    if (!newsItem.id) return null
    return (
      <Page title="Hírek" noHero>
        <div className="sectionTitle">{newsItem.cim}</div>
        <Grid className="NewsItem">
          <Row>
            <Col mdOffset={2} md={8}>
              <div className="dateAndAuthor">
                {newsItem.datum} - {newsItem.szerzo}
              </div>
              <div className="description">{newsItem['rovid-leiras']}</div>
              <div
                className="mainImage"
                style={{ backgroundImage: `url(${newsItem.fokep.url})` }}
              />
              <Col className="mainText">
                {RichText.render(newsItem.torzs || [])}
              </Col>
            </Col>
          </Row>
        </Grid>
      </Page>
    )
  }
}

export default NewsItem



// WEBPACK FOOTER //
// ./src/pages/NewsItem/index.js